export default __webpack_public_path__ + "static/logo-e189650a6e58aef1affe7d66e6eecb60.webp";